import React, { useState } from "react";
import LabTestingForm from "./LabTestingForm";
import LabTestingListview from "./LabTestingListview";

const TestingLabs = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <LabTestingForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
      ) : (
        <LabTestingListview addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
      )}
    </>
  );
};

export default TestingLabs;
